<template>
	<VideoListShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		:id-key="idKey"
		@select="$emit('select')"
	/>
</template>

<script>
	import VideoListShell from '../shared/VideoListShell.vue';
	import { mediaBlockEmits, mediaBlockProps } from '../shared/mediaBlockProps.js';

	export default {
		name: 'GBlockVideoList',
		components: { VideoListShell },
		props: mediaBlockProps,
		emits: mediaBlockEmits,
	};
</script>
